import * as actions from "./actionsType";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  collaboratorTypesLength: 0,
  collaboratorTypes: [],
  collaboratorType: {},
  collaboratorTypeError: "",
  formError: "",
};

export default function CollaboratorTypeReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_COLLABORATOR_TYPE:      
      return { ...state, loading: action.payload };

    case actions.LOADING_COLLABORATOR_TYPE_BY_ID:
      return { ...state, loadingById: action.payload };

    case actions.SAVE_LOADING_COLLABORATOR_TYPE:
      return { ...state, saveLoading: action.payload };

    case actions.GET_COLLABORATOR_TYPE:
      return {
        ...state,
        collaboratorTypes: action.payload.collaboratorTypes,
        collaboratorTypesLength: action.payload.collaboratorTypesLength,
      };

    case actions.GET_COLLABORATOR_TYPE_BY_ID:
      return { ...state, collaboratorType: action.payload };

    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };

    case actions.COLLABORATOR_TYPE_FAIL:
      return { ...state, collaboratorTypeError: action.payload };

    default:
      return state;
  }
}
